// extracted by mini-css-extract-plugin
export default {"blog":"blog-page_blog__VSE52","blogWrapper":"blog-page_blogWrapper__ZMk9v","mainTitle":"blog-page_mainTitle__4tj5u"};